import React, { useEffect, useRef } from 'react';
import * as echarts from "echarts";

// type = bar, line, scatter
const BasicChart = ({ height = 400, itemStyle = {}, categories = [], data = [], vertical = true, type = 'bar', showLabel = true, labelPostfix = '%', setAxis = true, opts, additionalSeries = [], series0 = {}, userOption }) => {

    const chartRef = useRef(null);

    useEffect(() => {
        const chartInstance = echarts.init(chartRef.current);
        let options;
        if (userOption) {
            options = userOption;
        } else {
            options = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                },

                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                series: [{
                    data: data,
                    type: type,
                    // barCategoryGap: '40%',
                    itemStyle: {
                        borderRadius: vertical ? [5, 5, 0, 0] : [0, 5, 5, 0],
                        ...itemStyle
                    },
                    emphasis: {
                        label: {
                            fontSize: 25
                        }
                    },
                    label: {
                        show: showLabel, // Show series label
                        position: vertical ? 'top' : 'right', // Position series label on top
                        formatter: '{c}' + labelPostfix, // Display the value of the data point
                        color: 'black' // Set series label color
                    },
                    ...series0
                },
                ...additionalSeries
                ],
                ...opts
            };

            if (setAxis) {
                if (vertical) {
                    options.xAxis = {
                        type: 'category',
                        data: categories,
                    };
                    options.yAxis = {
                        type: 'value',
                        show: false
                    };
                } else {
                    options.yAxis = {
                        type: 'category',
                        data: categories,
                    };
                    options.xAxis = {
                        type: 'value',
                        show: false
                    };
                }
            }
            // Set options and render chart
        }

        chartInstance.setOption(options);

        // Cleanup when component unmounts
        return () => {
            chartInstance.dispose();
        };
    }, [data]);

    return <div ref={chartRef} style={{ width: '100%', height: height }} />;
};

export default BasicChart;
